var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#888b8d",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 21.158a.75.75 0 0 1 .75-.75h20a.75.75 0 1 1 0 1.5H2a.75.75 0 0 1-.75-.75zM13.406 4.243a2.25 2.25 0 0 0-2.811 0l-8.126 6.501a.75.75 0 0 1-.937-1.171l8.126-6.501a3.75 3.75 0 0 1 4.685 0l8.126 6.501a.75.75 0 0 1-.937 1.171l-8.126-6.501z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.908a.75.75 0 0 1 .75.75v12.5a.75.75 0 1 1-1.5 0v-12.5a.75.75 0 0 1 .75-.75zm16 0a.75.75 0 0 1 .75.75v12.5a.75.75 0 1 1-1.5 0v-12.5a.75.75 0 0 1 .75-.75zm-8.049 4.5H12h.049l1.696.062c.492.066.963.215 1.345.597s.531.854.597 1.345c.062.459.062 1.032.062 1.696v5.049h-1.5v-5l-.048-1.546c-.044-.325-.114-.427-.171-.484s-.159-.128-.484-.171c-.347-.047-.818-.048-1.546-.048l-1.546.048c-.325.044-.427.114-.484.172s-.128.159-.171.484c-.047.347-.048.818-.048 1.546v5h-1.5v-5-.049l.062-1.696c.066-.492.215-.963.597-1.345s.854-.531 1.345-.597c.459-.062 1.032-.062 1.696-.062z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.7ffa9093ad3ae4a866eefef1ac997686.svg";
export { ForwardRef as ReactComponent };